import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { Provider } from 'react-redux';
import Page from '../pages/PartnerPages/Page';
import Loading from '../components/Loading';
import humps from 'humps';
import store from '../src/store';

const partnerId = window.gon.partner_id || '';

const PartnerPage = () => {
  const [partnerData, setPartnerData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPartnerData = async () => {
      try {
        const response = await axios.get(`/api/v6/partners/pages/${partnerId}`);
        const camelized = humps.camelizeKeys(response.data);
        console.log(camelized)
        setPartnerData(camelized);
      } catch (err) {
        setError(err.message || 'Failed to fetch partner data');
      } finally {
        setLoading(false);
      }
    };

    if (partnerId) {
      fetchPartnerData();
    } else {
      setLoading(false);
    }
  }, []);

  if (loading) return <div className="flex h-screen items-center justify-center"><Loading></Loading></div>
  if (error) return <p style={{ color: 'red' }}>{error}</p>;

  return (
    console.log('Rendering PartnersPage with data:', partnerData.data.slug),
    <Router>
      <Switch>
        <Route
          render={(props) => (
            <Page
              {...props}
              partnerId={partnerId}
              partnerData={partnerData.data}
            />
          )}
        />
      </Switch>
    </Router>
  );
};

document.addEventListener('DOMContentLoaded', () => {
  ReactDOM.render(
    <Provider store={store}>
      <PartnerPage />
    </Provider>,
    document.body.appendChild(document.createElement('div'))
  )
});
